const locale = {
  'c.ModifyPassword.title': 'Modify Password',

  'c.ModifyPassword.label.oldPassword': 'Original Password',
  'c.ModifyPassword.placeholder.oldPassword': 'Please enter the original password',

  'c.ModifyPassword.label.newPassword': 'New Password',
  'c.ModifyPassword.placeholder.newPassword':
    '8-26 characters (including uppercase letters, lowercase letters and numbers)',
  'c.ModifyPassword.rule.newPassword.min': 'The password length cannot be less than 8 characters!',
  'c.ModifyPassword.rule.newPassword.repeat':
    'The new password cannot be the same as the original password!',

  'c.ModifyPassword.label.confirmPassword': 'Confirm Password',
  'c.ModifyPassword.placeholder.confirmPassword': 'Please confirm the new password again',
  'c.ModifyPassword.rule.confirmPassword.inconsistent':
    'The two password entries are inconsistent!',

  'c.ModifyPassword.button.submit': 'Save',

  'c.ModifyPassword.request.loading': 'Modifying password...',
  'c.ModifyPassword.request.success': 'Password modified successfully. Please log in again.',
  'c.ModifyPassword.request.error': 'Password modification failed! Please try again later.',
};
export default locale;
